import {
    ClientsCloseOverviewColumn,
    ClientsCloseOverviewView,
} from "@common/types/views/clientsCloseOverviewView";
import { NamedView, ViewDensity, ViewType } from "@common/types/views/views";
import { useMemo } from "react";

export function useDefaultClientsClosesView(): NamedView<ClientsCloseOverviewView> {
    return useMemo(
        () => ({
            id: "default",
            name: "All Clients",
            type: ViewType.CLIENTS_CLOSE_OVERVIEW,
            options: {
                selection: false,
                bulkActions: false,
                density: ViewDensity.MD,
            },
            columns: [
                {
                    id: ClientsCloseOverviewColumn.CLIENT,
                    options: { pin: "left" },
                },
                { id: ClientsCloseOverviewColumn.ENTITIES },
                { id: ClientsCloseOverviewColumn.TEAM },
                { id: ClientsCloseOverviewColumn.ACCESS },
                { id: ClientsCloseOverviewColumn.PLAN },
                { id: ClientsCloseOverviewColumn.BILLING_OWNERSHIP },
                { id: ClientsCloseOverviewColumn.LEGAL_TYPE },
                { id: ClientsCloseOverviewColumn.CREATED_AT },
                {
                    id: ClientsCloseOverviewColumn.ACTIONS,
                    options: { pin: "right" },
                },
            ],
            filters: {},
        }),
        [],
    );
}
